export default (props, traits) => {
  return {
    root: {
      textAlign: 'center'
    }
  }
}
